<ea-button-link
	name="logout"
	(onClick)="openConfirmModal()"
	data-cy="logout-link"
>
	Log Out <span class="fa fa-sign-out fa-lg"></span>
</ea-button-link>

<!-- logout confirmation modal -->
<ea-modal
	[size]="MODAL_SIZES.Medium"
	[modalId]="constants.modalIds.LOGOUT_CONFIRMATION"
	title="Logout"
>
	<ng-template #modalBody>
		<ea-form-required-instructions></ea-form-required-instructions>
		<div class="logout-content-text">
			<ea-paragraph>
				<span class="text-wrap">{{ constants.LOGOUT.CONTENT_TEXT }}</span>
				<span class="required-asterisk">*</span>
			</ea-paragraph>
		</div>
		<hr />
		<ea-button
			name="logoutConfirm"
			(onClick)="logout()"
			data-cy="logout-confirm-button"
			>Logout</ea-button
		>
		<ea-button
			[type]="BUTTON_TYPES.Secondary"
			name="logoutConfirmCancel"
			(onClick)="cancel()"
			data-cy="logout-cancel-button"
			>Cancel</ea-button
		>
	</ng-template>
</ea-modal>
